export default function () {
  const widgetName = 'cardWidgetVideo';
  const widgetOpts = cardWidgetVideoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (slide) { 
      function addClass() {
        $(`#${widgetName} .card-widget-item`).each(function (x) {

          let vimeoURLAttr = $(slide.items[x].Description).find('iframe').attr('src') // This line extracts the SRC from video embed code
          let videoActive = slide.items.length; // Check if video is loaded
          vimeoURLAttr = `${vimeoURLAttr}&background=1` // Take the SRC variable token and add attribute background, allows autoplay and button removal

          $(this).find('.card-widget-description iframe').attr('src', vimeoURLAttr) // Add the SRC back again to inside the iframe description
          $(this).find('.card-widget-title').remove() // Remove title 
          $(this).find('.buttonwrap').remove() // Remove button

          // if (videoActive >= 1) {
          //   $('$swiperWidget').remove() // If there is a video loaded, disable swiper
          // } else {
          //   $($this).remove() // Otherwise we remove the video and keep the swiper
          // }
          
        })

      }
      addClass()

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev', 'Next'],
      nav: true
    },
    textOverImage: true
  });

}